import { Link } from "react-router-dom";
import { HiOutlineLink } from "react-icons/hi";
import { IoMdClose } from "react-icons/io";
import toast, { Toaster } from "react-hot-toast";

import "./popup.css";

const PopUp = ({ link, setShowing }) => {
  function getTarget() {
    try {
      const url = new URL(link);
      const isSameOrigin =
        typeof window !== "undefined" && url.origin === window.location.origin;
      return {
        to: isSameOrigin ? `${url.pathname}${url.search}${url.hash}` : link,
        external: !isSameOrigin,
      };
    } catch (e) {
      // If URL parsing fails, fall back to opening as external
      return { to: link, external: true };
    }
  }
  const { to, external } = getTarget();

  function copyLink() {
    navigator.clipboard
      .writeText(link)
      .then(() => toast.success("Link copied to clipboard"));
  }

  return (
    <div className="overlay" onClick={() => setShowing(false)}>
      <section className="popup" onClick={(e) => e.stopPropagation()}>
        <IoMdClose
          className="close"
          size="1.5rem"
          onClick={() => setShowing(false)}
        />
        <h2>Voila!</h2>
        <div className="link" onClick={copyLink}>
          <input type="text" readOnly value={link} />
          <span>
            <HiOutlineLink size="0.75rem" style={{ marginRight: "0.5rem" }} />
            Copy link
          </span>
        </div>
        {external ? (
          <a href={to} target="_blank" rel="noopener noreferrer">
            <button className="visit" onClick={() => setShowing(false)}>
              Visit page
            </button>
          </a>
        ) : (
          <Link to={to}>
            <button className="visit" onClick={() => setShowing(false)}>
              Visit page
            </button>
          </Link>
        )}
      </section>
      <Toaster />
    </div>
  );
};

export default PopUp;
